import { ReactNode } from "react";
import styles from "./CheckBox.module.scss";

interface IProps {
  checked: boolean;
  label: string | ReactNode;
  onChange?: (e: any) => void;
  style?: {};
  className?: string;
  disabled?: boolean;
}

const CheckBox = (props: IProps) => {
  return (
    <label
      className={[styles.checkBoxContainer, props.className].join(" ")}
      style={{ ...props.style }}
    >
      <span className="mt-1">{props.label}</span>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span className={styles.checkmark}></span>
    </label>
  );
};

export default CheckBox;
